<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="cop01">
<a id="pagevi"></a>
<p class="copyrightText">R<span class="smallCaps">ULE</span> Y<span class="smallCaps">OUR</span> F<span class="smallCaps">REAKIN</span>’ R<span class="smallCaps">ETIREMENT</span>.<br/>

Copyright © 2009 by Michael Parness.<br/>

All rights reserved.<br/>
Printed in the United States of America.<br/>
For information, address St. Martin’s Press,<br/> 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="copyrightText"><span class="xrefURL"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></span></p>
<p class="copyrightText"><span class="smallCaps">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="copyrightText">Parness, Michael.</p>
<p class="para">Rule your freakin’ retirement: how to retire rich by actively managing your assets / Michael Parness.—1st ed.<br/>                  p. cm.</p>
<p class="copyrightTexta">    ISBN-13: 978-1-4299-6256-8<br/>    ISBN-10: 0-312-37575-1</p>
<p class="para">1. Retirement income—Planning. 2. Retirement—Planning. 3. Old age pensions. 4. Investments. 5. Finance, Personal. I. Title.</p>
<p class="copyrightTexta">    HG179.P237 2009</p>
<p class="copyrightTexta">    332.024'014—dc22</p>
<p class="copyrightTextb">2008035448</p>
<p class="copyrightTexta">  First Edition: March 2009</p>
<p class="copyrightTexta"> </p>
<p class="copyrightTexta">  10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ruleyourfreakinretirement_cop01.vue?1f05175d